import moment from "moment";
import { environment } from "../../../environments/environment";
import { FormControl, ValidationErrors } from "@angular/forms";

export class DateValidator {
    static MinData(control: FormControl): ValidationErrors | null {
        if (
            moment(control.value).isBefore(
                moment().add(environment.minHoursForTicketSchedulation, "hours")
            )
        ) {
            return { invalidDate: true };
        }

        return null;
    }
}
